var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.ref,staticClass:"dv-charts-container"},[_c('div',{ref:_vm.chartRef,staticClass:"charts-canvas-container"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d283f50a","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@jiaminghi/data-view/lib/components/charts/src/main.vue
// module id = 1577
// module chunks = 45